import React from 'react';
import '../App.css';

const Header = ({title}) => {
	return (
		<h1>{title}</h1> 
		);
}

export default Header;